var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_61)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3152_61",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "url(#pattern0_3152_61)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3152_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "#172B4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3152_61",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3152_61",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3152_61",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAC/0lEQVR4nO3cQW6cMBhA4b9Vt1Eu0Kxz9kSRsu6iN2orlTlAugiVRiEYBmxs/N4nsWqaYciTxZixI5geIuIlIobxeI2Ix6pnpMM8RMTviHj7cPwZ/02de4npH///8VzxvHSQIeYD+FvxvKr4UvsEKnhb+HfUNfla+wRUlwHAGQCcAeRxPa8wd4N51OG8xoKlC3iruXmF2ofzGjNyB5CaV6h9LM5roD7yjHJ/DBwi4m7juZQ2RMR96gcMYOrWa7Jl1DhS8v14EwhnAHAGAPet9gkAlL7P2nUP4ggAZwBwBgBnAHAGAGcAcAYA5zzAVOtz+1k5AsAZAJwBwBkAnAHAGQCcAcA5DzDV23cCkxwB4AwAzgDgDADOAOAMAM4A4JwHKK/peQJHADgDgDMAuLUBuAfOvEvtE0jIsvFlb3vg5N4i5rXQ+8txPG14PxOn3gPnE7kDeIz3GGtfi4/Hr4j4vuH9TLQw7M8dW4a43AFEvI9Ez+P5tHBNnmLlH3/Ns++tF+UouZ/fo/ZN8lMAnAHAGQBcjmcBTe+BozRHADgDgDMAOAOAMwA4A4AzALgevhPoPMEOjgBwBgBnAHAGAGcAcAYAZwBwPcwDoPb0yc0RAM4A4AwAzgDy6HrtZImVNDVfP/fv623t5IQBpJ167WSOpWG1vxZee2nYEBF3N/6fowwRcZ/6AdcGlv99tSXfjzeBcAYAZwBwa54FXKLdm5wse+AUVvsmOWnNCPBzzwsU9qP2CRD0tgdO6/MKTb7+affA+YQBXEHthzNqfWLpVrte308BcAYAZwBwPXwnMLfW5/azcgSAMwA4A4AzADgDgDMAOAOAcx5gqrfvBCY5AsAZAJwBwBkAnAHAGQCcAcA5D1Be0/MEjgBwBgBnAHAGsN+l9gkkLK6dNID9XDt5MrmXcvW2drJ7JdbynXbtpGsDp1DXxHsAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADhiAKnn92fYezgrYgCp5/c+PweYe37v83OQ6+f3e/cePrV/1HViFFjElYkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/multi.890d01bcb512920f598b2839603c20a8.svg";
export { ForwardRef as ReactComponent };